const StopSpeechRecognition = ({
  recognitionRef,
  setIsDictating,
  setInterimTranscript,
  dictationBaseRef,
  dictatedFinalRef,
  setNewComment,
}) => {
  try {
    if (recognitionRef.current) {
      recognitionRef.current.onend = null
      recognitionRef.current.stop()
    }
  } catch {}

  setIsDictating(false)
  setInterimTranscript("")
  recognitionRef.current = null
}

export default StopSpeechRecognition


